'use strict'
window.addEventListener("load", function () {
  let burgerClick = document.querySelector('.burger');
  let getMenu = document.querySelector('.nav');
  let x = window.matchMedia("(max-width: 767px)");

  // remove white colors for Our Pets Nav Burger
  let white = document.querySelectorAll('.header--ourSubtitle, .header--ourTitle');

  function remWhColor() {
    white.forEach(function (item) {
      item.style.color = '#292929';
    });
  }

  // Delete rotate class and add rotateback for
  function rotateBack() {
    burgerClick.classList.remove('rotate');
    burgerClick.classList.add('rotateback');
    remWhColor();
  }

  burgerClick.addEventListener('click', function () {
    getMenu.classList.toggle('active');
    rotateBack();
    if (getMenu.classList.contains('active')) {
      burgerClick.classList.add('rotate');
      burgerClick.classList.remove('rotateback');
      white.forEach(function (item) {
        item.style.color = 'white';
      });
    } else if (x.matches) {
      rotateBack();
      remWhColor();
    }
  });

  // remove navbar when user click to link
  let linkClickThenCloseBrg = document.querySelectorAll('.menu__item');
  linkClickThenCloseBrg.forEach(function (item) {

    let getReady = item.addEventListener('click', function () {
      if (getMenu.classList.contains('active')) {
        getMenu.classList.remove('active');
        burgerClick.style.top = '0px';
        rotateBack();
        remWhColor();
      }
    })
  })
});
